// @flow
import React from "react";
import styled, { css } from "styled-components";
import { media, Link, ButtonGroup } from "@nested/ui";
import { RichText } from "../shared/RichText";
import SwooshWrapper from "../shared/Swoosh/Wrapper";

const Wrapper = styled.div`
  text-align: center;
  padding: 25px 10px;

  ${media.tablet`
    padding: 50px 35px;
  `};

  ${({ theme, colour, backgroundColor }) =>
    backgroundColor === "Yes"
      ? css`
          background-color: ${theme.palette[colour].extraLight};
        `
      : null};
`;

const Content = styled(RichText)`
  &,
  && * {
    text-align: ${({ textAlign }) =>
      textAlign === "center" ? "center" : "left"};
  }
  max-width: ${({ theme }) => theme.typography.maxWidth.large};
  margin: auto;
  padding-bottom: ${({ isButtonVisible }) =>
    isButtonVisible ? "50px" : "0px"};
`;

type Props = {
  mainText: any[],
  firstButtonLabel?: string,
  firstButtonLink: PrismicLink,
  secondButtonLabel?: string,
  secondButtonLink: PrismicLink,
  colour: string,
  backgroundColor: string,
  swoosh: string,
  textAlign?: string,
};

const RichTextWithButtons = ({
  mainText,
  firstButtonLabel,
  firstButtonLink,
  secondButtonLabel,
  secondButtonLink,
  colour,
  backgroundColor,
  swoosh,
  textAlign = "center",
}: Props) => (
  <section>
    <SwooshWrapper swoosh={swoosh} colour={colour}>
      <Wrapper backgroundColor={backgroundColor} colour={colour}>
        <Content
          center
          textAlign={textAlign}
          isButtonVisible={firstButtonLabel || secondButtonLabel}
        >
          {mainText}
        </Content>
        <ButtonGroup>
          {firstButtonLabel && firstButtonLink && (
            <Link inverted colour={colour} to={firstButtonLink.url}>
              {firstButtonLabel}
            </Link>
          )}

          {secondButtonLabel && secondButtonLink && (
            <Link colour={colour} to={secondButtonLink.url}>
              {secondButtonLabel}
            </Link>
          )}
        </ButtonGroup>
      </Wrapper>
    </SwooshWrapper>
  </section>
);

export default RichTextWithButtons;
